module.exports = {
  back: 'Kembali',
};
